import { Component, OnInit, OnDestroy } from '@angular/core';
import { Option } from 'src/app/models/option';
import { takeWhile, map } from 'rxjs/operators';
import { ModalController } from '@ionic/angular';
import { OptionAddEditModalComponent } from '../option-add-edit-modal/option-add-edit-modal.component';
import { UiUtils } from 'src/app/util/ui-utils';
import { TranslateService } from '@ngx-translate/core';
import {OptionGroupService} from '../../services/option-group.service';
import {ShopService} from '../../services/shop.service';
import {OptionGroup} from '../../models/option-group';
import {CategoryService} from '../../services/category.service';

@Component({
  selector: 'app-option-list',
  templateUrl: './option-list.component.html',
  styleUrls: ['./option-list.component.scss'],
})
export class OptionListComponent implements OnInit, OnDestroy {

  restaurantOptions: OptionGroup[];

  private isComponentActive = true;

  constructor(
    private optionService: OptionGroupService,
    private modalController: ModalController,
    private uiUtils: UiUtils,
    private shopService: ShopService,
    private translateService: TranslateService,
    private categoryService: CategoryService
  ) { }

  ngOnInit() {

    this.optionService.observeOptionGroups()
    .pipe(
        takeWhile(() => this.isComponentActive),
        map(options => options.sort((a, b) => {
            if ( a.name > b.name ) { return  1; }
            if ( a.name < b.name ) { return -1; }
            return 0;
        }))
    )
    .subscribe((options) => this.restaurantOptions = options);
  }

  async editOption(option: Option) {
    const modal = await this.modalController.create({
      component: OptionAddEditModalComponent,
      backdropDismiss: false,
      componentProps: { option: { ...option } }
    });

    modal.onDidDismiss().then(async ({ data }) => {
      if (!data) { return; }
      if (!data.option) { return; }

      this.optionService.updateOptionGroup(data.option);
    });

    await modal.present();
  }

  removeOption(option: OptionGroup) {
    this.uiUtils.showConfirmAlert(
      this.translateService.instant('component.option_list.message.confirmRemoved'),
      this.translateService.instant('component.option_list.message.permanentAction'),
      this.translateService.instant('generic.accept'), () => {
        this.optionService.removeOptionGroup('');
        this.removeOptionOnAllItems(option.options[0]);
      },
      this.translateService.instant('generic.cancel')
    );
  }

  private removeOptionOnAllItems(option: Option) {
    this.categoryService.getCurrentCategories()
    .pipe(takeWhile(() => this.isComponentActive))
    .subscribe((categories) => {
      categories.forEach(category => {
        if (!category.items || category.items.length === 0) { return; }
        category.items.forEach(item => {
          // if (!item.options || item.options.length === 0) { return; }
          // item.options = item.options.filter((itemOption => itemOption.optionId !== option.uid));
          // this.restaurantService.updateCategory(restaurantKey, category.key, {...category});
        });
      });
    });
  }

  ngOnDestroy() {
    this.isComponentActive = false;
  }

}
